import { createRoot } from "react-dom/client";
import "@amzn/awsui-global-styles/polaris.css";

const container = document.getElementById("root");
const root = createRoot(container!);

import RoutesConfiguration from "./routes";
import AuthLoading from "common/component/AuthLoading/AuthLoading";
import { UxmProvider } from "@amzn/uxm-aws-ui-components-react/lib/src/uxm/provider";
import { config, retrieveUxmStage } from "configuration/config";

/** Current stage for uxm */
const STAGE = retrieveUxmStage();

export const MainApp = () => (
    <AuthLoading>
        <UxmProvider appId={config.analytics.uxmAppId} stage={STAGE}>
            <RoutesConfiguration />
        </UxmProvider>
    </AuthLoading>
);

root.render(<MainApp />);
